import React, { useState, FC, useEffect } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import { RouterParamType } from "@/model/navModel";
import { useDtpDetailModel } from "../dtpDetailModel";
import { customerService } from "@/views/base/customer/customerService";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { salesService } from '@/views/sales/salesService';
import { mdmService } from "@/views/public/mdmService";
import { enquiryService } from "@/views/document/customs/dtpService";
import moment from "moment";

export const FormBox: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const {
        addFormVal,
        editFormVal,
        updateFormVal,
    } = useDtpDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);

    const { fetchSalesList, fetchCustomerList, user: { shopCode } } = useGlobalModel(({ user }) => [user]);
    const { getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);

    const formVal = mode === "edit" ? editFormVal : addFormVal;

    //回显选中客户带出来的数据
    const getCustomer = async (id: string) => {
        let { retData } = await customerService.one(id);
        let data = {
            customerCode: retData.code,
            customerName: retData.name,
            customerId: retData.id,
            phone: retData.phone,
            contact: retData.contact,
            countryCode: retData.countryCode,
            countryName: retData.countryName
        }
        updateFormVal(mode, data);
    }

    //客户选中
    const customerChange = (value: string, option: ISelectOption) => {
        if (option && option.id) {
            getCustomer(option.id as string)
        }
    }

    //回显选中外贸合同信息
    const getSale = async (code: string) => {
        //debugger
        let { retData } = await salesService.one(code);
        //托运日期，发货地址，收获地址，发货人电话,发货人传真,收货人传真,成交方式,
        let {
            bentityCode,
            bentityName,
            customerCode,
            customerName,
            relevanceOrderId,
            transportMode,
            phone: consigneePhone,
            shipment,
            discharge,
            countryCode: country,
            clause: bargainType, //贸易条款
            addAmount: otherExpenses,
            shippingMark,
        } = retData as any
        //查客户信息
        let { retData: { records } } = await customerService.page({
            shopCode,
            pageSize: 15,
            pageNum: 1,
            code: customerCode
        })
        let customerData = records?.[0] ?? {};

        //查询实体
        let { retData: beData } = await mdmService.getMdmBeOne(bentityCode as string);
        //查出运的信息
        let { retData: shipmentInfo } = await enquiryService.findBySaleCodeTotal(code);
        //查物流进程
        let { retData: logData } = await salesService.oneLog(code);
        let data = {
            customerCode,
            customerName,
            relevanceOrderId,
            transportMode,
            phone: consigneePhone,
            shipment,
            discharge,
            country,
            bargainType, //贸易条款
            otherExpenses,
            labelNote: shippingMark,
            saleId: retData.id,
            shippingAddress: customerData.address,
            consigneePhone: customerData.phone,
            bentityCode,
            bentityName,
            shipAddress: beData?.address,
            consignerPhone: beData?.phone,
            consigneeFax: beData?.faxes,
            saleCode: code,
            packingNum: shipmentInfo?.number, // 带出商品件数,
            roughWeight: shipmentInfo?.grossWeightTotal, // 总毛重,
            consignTime: logData?.consignmentTime ? moment(logData?.consignmentTime) : null,
            volume: shipmentInfo?.volume  //带出体积信息
            // shippingAddress:customerData[0]
        }
        updateFormVal(mode, data);
    }

    //外贸合同号选中
    const saleCodeChange = (value: string, option: ISelectOption) => {
        if (option && value) {
            getSale(value as string)
        }
    }

    //币种选中
    const currencyChange = (value: string, option: ISelectOption) => {
        option && updateFormVal(mode, { currencyCode: option.value, currencyName: option.label });
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(mode, values);
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "10px" },
        contentClass: "pr-2",
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "运输单据号",
            //     fieldName: "shipmentInvoicesCode",
            //     // disable: true,
            //     rules: [{ required: true, message: "请填写运输单据号" }]
            // },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "外贸合同号",
                fieldName: "saleRealCode",
                selectfetchList: fetchSalesList,
                onSelectChange: saleCodeChange,
                rules: [{ required: true, message: "请选择外贸合同号" }],
                defaultQuery: formVal.saleRealCode
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "贸易国别",
                fieldName: "country",
                allowClear: true,
                options: getSelectedDictOne(DictCodeEnmu.COUNTRY),
                rules: [{ required: true, message: "请选择贸易国别" }],
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运输方式",
                fieldName: "transportMode",
                options: getSelectedDictOne(DictCodeEnmu.TRANSPORT_MODE),
                onSelectChange: currencyChange,
                rules: [{ required: true, message: "请选择运输方式" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "托运日期",
                fieldName: "consignTime",
                rules: [{ required: true, message: "请选择托运日期" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发货人",
                fieldName: "bentityName",
                span: 12,
                labelCol: { span: 4 },
                rules: [{ required: true, message: "请选择发货人" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收货人",
                fieldName: "customerName",
                span: 12,
                labelCol: { span: 4 },
                rules: [{ required: true, message: "请选择收货人" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发货地址",
                fieldName: "shipAddress",
                span: 12,
                labelCol: { span: 4 },
                rules: [{ required: true, message: "请选择发货地址" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收货地址",
                fieldName: "shippingAddress",
                span: 12,
                labelCol: { span: 4 },
                rules: [{ required: true, message: "请选择收货地址" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发货人电话",
                fieldName: "consignerPhone",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发货人传真",
                fieldName: "consigneeFax",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收货人电话",
                fieldName: "consigneePhone",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收货人传真",
                fieldName: "consignerFax",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "通知人",
                fieldName: "notifier",
                span: 12,
                labelCol: { span: 4 }
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "装货港",
                allowClear: true,
                fieldName: "shipment",
                options: getSelectedDictOne(DictCodeEnmu.LOAD_PORT),
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "卸货港",
                fieldName: "discharge",
                allowClear: true,
                options: getSelectedDictOne(DictCodeEnmu.DISCHARTGE_PORT),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "包装及件数",
                fieldName: "packingNum",
                span: 12,
                labelCol: { span: 4 }
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "成交方式",
                fieldName: "bargainType",
                options: getSelectedDictOne(DictCodeEnmu.TRADE_CLAUSE),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "海关编码",
                fieldName: "customsCode",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货物名称",
                fieldName: "goodsName",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "唛头",
                fieldName: "labelNote",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "毛重",
                fieldName: "roughWeight",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "体积",
                fieldName: "volume",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "特约事项",
                fieldName: "specialRemark",
                span: 12,
                labelCol: { span: 4 }
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "其他费用",
                fieldName: "otherExpenses",
                span: 12,
                labelCol: { span: 4 }
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerCode",
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发货人名称",
                fieldName: "bentityCode",
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发货人名称",
                fieldName: "bentityCode",
                hidden: true,
            },
        ]
    };

    const stockEntryFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 8 },
        labelAlign: "right",
        formValues: formVal,
        disabled: formVal.status === 'transport-status.effect' ? true : false,
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...stockEntryFromConfig} />
    )
}